import firebase from "firebase";
const config = {
    apiKey: "AIzaSyCEBS0Uq9pD92z8TufsOtA_3KdA-LYRp30",
    authDomain: "wiwer-881f8.firebaseapp.com",
    databaseURL: "https://wiwer-881f8.firebaseio.com",
    projectId: "wiwer-881f8",
    storageBucket: "wiwer-881f8.appspot.com",
    messagingSenderId: "672952484017",
    appId: "1:672952484017:web:3177dcd7701347e83ae290",
    measurementId: "G-46MBXBXSRX"
  };
firebase.initializeApp(config);
// firebase.database();
export default firebase;